import React, { useState } from 'react';
import {
  CmhcIcon,
  CmhcIconSize,
  Button,
  ButtonSize,
  ButtonVariant,
  FlyoutContainer,
  Link
} from '@cmhc-schl/hearth-ui';
import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { useHistory } from 'react-router-dom';

interface ResourcesFlyout {
  linkText: string;
  link: string;
  buttonText: string;
}

// eslint-disable-next-line no-redeclare
export const ResourcesFlyout = ({ linkText, link, buttonText }: ResourcesFlyout) => {
  const [openFlyout, setOpenFlyout] = useState<boolean>(false);
  const { t } = useTranslation('HbtPortfolioManagementRequestOverview');
  const history = useHistory();

  const toggleResourcesFlyout = (newOpen: boolean) => {
    setOpenFlyout(newOpen);
  };
  return (
    <Box className={styles.resourcesFlyoutContainer}>
      <Stack direction="row" className={styles.resourcesStack}>
        <Button
          type="button"
          name={linkText}
          size={ButtonSize.SMALL}
          variant={ButtonVariant.TERTIARY}
          leadingIcon={() => (
            <CmhcIcon className={styles.error} size={CmhcIconSize.SMALL} type="icon_table_chart" />
          )}
          text={{
            value: linkText
          }}
          ariaText={{
            value: linkText
          }}
          onClick={(e) => {
            e.stopPropagation();
            history.push(link);
          }}
          className={styles.resourcesLink}
        />
        <Button
          className={styles.resourcesButton}
          type="button"
          name="documents_resources"
          size={ButtonSize.SMALL}
          variant={ButtonVariant.TERTIARY}
          leadingIcon={() => <CmhcIcon size={CmhcIconSize.SMALL} type="icon_support" />}
          text={{
            value: buttonText
          }}
          ariaText={{
            value: buttonText
          }}
          onClick={() => toggleResourcesFlyout(true)}
        />
      </Stack>
      <FlyoutContainer
        id="validation-review-documents-resources-flyout-container"
        isHeaderRequired={true}
        headerText={t('PI-Portfolio-Management-Validation-Review-Documents-Resources')}
        open={openFlyout}
        onClose={() => {
          toggleResourcesFlyout(false);
        }}
        content={
          <Box className={styles.documentsResourcesflyoutContainer} role="presentation">
            <Box className={styles.documentsResourcesflyoutLinksContainer}>
              <Link
                target="_blank"
                leadingIcon={() => <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_pdf" />}
                ariaLabel={t(
                  'PI-Portfolio-Management-Request-Overview-Insurance-Processing-User-Guide'
                )}
                href={t(
                  'PI-Portfolio-Management-Request-Overview-Insurance-Processing-User-Guide-Link'
                )}
                data-testid="user-guide-link"
              >
                {t('PI-Portfolio-Management-Request-Overview-Insurance-Processing-User-Guide')}
              </Link>
              <Link
                target="_blank"
                leadingIcon={() => <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_file_word" />}
                ariaLabel={t(
                  'PI-Portfolio-Management-Request-Overview-Insurance-Processing-Procedures'
                )}
                href={t(
                  'PI-Portfolio-Management-Request-Overview-Insurance-Processing-Procedures-Link'
                )}
                data-testid="procedure-link"
              >
                {t('PI-Portfolio-Management-Request-Overview-Insurance-Processing-Procedures')}
              </Link>
              <Link
                target="_blank"
                leadingIcon={() => <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_msexcel" />}
                ariaLabel={t('PI-Portfolio-Management-Request-Overview-Insurance-Processing-Rules')}
                href={t('PI-Portfolio-Management-Request-Overview-Insurance-Processing-Rules-Link')}
                data-testid="rules-link"
              >
                {t('PI-Portfolio-Management-Request-Overview-Insurance-Processing-Rules')}
              </Link>
              <Link
                target="_blank"
                leadingIcon={() => <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_msexcel" />}
                ariaLabel={t(
                  'PI-Portfolio-Management-Request-Overview-Insurance-Processing-Tracker'
                )}
                href={t(
                  'PI-Portfolio-Management-Request-Overview-Insurance-Processing-Tracker-Link'
                )}
                data-testid="tracker-link"
              >
                {t('PI-Portfolio-Management-Request-Overview-Insurance-Processing-Tracker')}
              </Link>
            </Box>
          </Box>
        }
      />
    </Box>
  );
};
